import { LicenseMonthlySubscriptionSubFormWebComponent } from './component/LicenseMonthlySubscriptionSubFormWebComponent';
import { WEB_COMPONENT_LICENSE_MONTHLY_SUBSCRIPTION_SUBFORM } from '../../webcomponents.constants';

export { LicenseMonthlySubscriptionSubFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_LICENSE_MONTHLY_SUBSCRIPTION_SUBFORM,
  LicenseMonthlySubscriptionSubFormWebComponent
);
